import { useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useJourney } from "../JourneyContext";
import { ContinueButton, StageFrame } from "../StageChrome";
import { PULL_CONCEPTS, seedPullsFromWorlds } from "../intentionData";

const POSITIONS = [[13,18],[37,8],[64,12],[84,25],[91,54],[74,78],[49,87],[22,80],[7,58],[30,47],[58,48],[48,25]];

export const PullStage = () => {
  const { journey, completeStage } = useJourney();
  const initial = useMemo(() => {
    if (journey.signals.pulls?.length) return Object.fromEntries(journey.signals.pulls.map((item) => [item.key, item.weight]));
    return seedPullsFromWorlds(journey.signals.worlds);
  }, [journey.signals.pulls, journey.signals.worlds]);
  const [scores, setScores] = useState(initial);
  const fieldRef = useRef(null);
  const nodeRefs = useRef({});

  const feelGravity = (point) => {
    const next = { ...scores };
    PULL_CONCEPTS.forEach((concept) => {
      const rect = nodeRefs.current[concept]?.getBoundingClientRect();
      if (!rect) return;
      const distance = Math.hypot(point.x - (rect.left + rect.width / 2), point.y - (rect.top + rect.height / 2));
      next[concept] = Math.max(next[concept] || 0, Math.max(0, 1 - distance / 260));
    });
    setScores(next);
  };

  const top = Object.entries(scores).sort((a, b) => b[1] - a[1]).slice(0, 5);
  const finish = () => completeStage("pulls", top.map(([key, weight], order) => ({ key, weight: Math.max(.1, Math.min(1, weight)), order })));

  return (
    <StageFrame eyebrow="THE PULL" title="Some things pull us more than others." instruction="Move the HUMN orb through the gravity field." className="pull-stage" testId="stage-2-pull">
      <div ref={fieldRef} className="gravity-field" data-testid="stage-2-gravity-field">
        {PULL_CONCEPTS.map((concept, index) => <button ref={(node) => { nodeRefs.current[concept] = node; }} key={concept} type="button" onClick={() => setScores((current) => ({ ...current, [concept]: Math.min(1, (current[concept] || 0) + .28) }))} className="gravity-concept" aria-pressed={top.some(([key]) => key === concept)} style={{ "--x": `${POSITIONS[index][0]}%`, "--y": `${POSITIONS[index][1]}%`, "--strength": scores[concept] || .08 }} data-testid={`stage-2-concept-${concept.toLowerCase()}`}>{concept}<i /></button>)}
        <motion.button type="button" className="humn-gravity-orb" drag dragConstraints={fieldRef} dragElastic={.08} dragMomentum={false} onDrag={(_, info) => feelGravity(info.point)} aria-label="Move the HUMN orb" data-testid="stage-2-humn-orb"><img src="/brand/humn-mark.png" alt="" /><span>MOVE ME</span></motion.button>
        <div className="gravity-strongest" data-testid="stage-2-strongest-signals">{top.slice(0,3).map(([item]) => <strong key={item}>{item}</strong>)}</div>
      </div>
      <ContinueButton onClick={finish} disabled={top.filter(([, value]) => value >= .28).length < 3} label="Carry what stayed bright" testId="stage-2-continue-button" />
    </StageFrame>
  );
};